import { ExternalLink } from '@signate-cloud/ui-lib/src/components/slims/ExternalLink';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

export const OutOfServiceAnnouncement = () => {
  return (
    <>
      {dayjs().isBetween('2023-12-18', '2024-01-04', null, '[]') && (
        <div className="card-body bg-white bd bd-gray-500 rounded-10 pd-15 mg-b-15">
          <h5 className="card-title tx-dark tx-medium tx-center mg-b-10">
            お知らせ
          </h5>
          <p className="card-text">
            年末年始の休業期間は2023/12/27(水) ~ 2024/01/04(木)となります。
            年末年始期間中のお問い合わせは年明けの営業開始日以降、順次ご回答いたします。
            <br />
            詳しくは
            <ExternalLink
              href="https://signate.co.jp/news/2023/202312181100.html"
              external={true}
              linkText="こちら"
            />
          </p>
        </div>
      )}
    </>
  );
};
